class PazzlesPicker extends HTMLElement{
	constructor() {
		super();
	}

	connectedCallback() {
		this.initElements();
		this.initEvents();
	}

	initElements() {
		this.tabButtons = this.querySelectorAll("[data-pazzles-picker-tab-button]");
		this.activeButton = this.querySelector("[data-pazzles-picker-tab-button].active");
		this.activeTabContent = this.querySelector("[data-pazzles-picker-tab-content].active");
		this.activeTabGallery = this.querySelector("[data-pazzles-picker-tab-gallery]:not(.hidden)");
	}

	initEvents() {
		this.tabButtons.forEach(button => {
			button.addEventListener("click", () => {
				if (button == this.activeButton) {
					return null;
				}

				const tabSelector = button.getAttribute("data-pazzles-picker-tab-button");

				const tabContent = this.querySelector(`[data-pazzles-picker-tab-content="${tabSelector}"]`);
				const tabGallery = this.querySelector(`[data-pazzles-picker-tab-gallery="${tabSelector}"]`);

				if (!tabContent) {
					return null;
				}

				this.activeButton.classList.remove("active");
				this.activeTabContent.classList.remove("active");
				this.activeTabGallery?.classList.remove("active");

				button.classList.add("active");
				tabContent.classList.add("active");
				tabGallery?.classList.add("active");
				this.activeButton = button;
				this.activeTabContent = tabContent;
                if (tabGallery) {
  				this.activeTabGallery = tabGallery;
                }
			});
		})
	}

}

if (!window.customElements.get("pazzles-picker")) {
	window.customElements.define("pazzles-picker", PazzlesPicker);
}

class PazzlesPickerThumbSlider extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.initSlider();
	}

	initSlider() {
		this.sliderContainer = this.querySelector("[data-pazzles-picker-thumb-gallery]");

		if (!this.sliderContainer) {
			return null;
		}

		this.options = {
			slidesPerView: "auto",
			spaceBetween: 0,
			observer: true,
			observeParents: true,
			slideToClickedSlide: true
		}

		this.slider = new Swiper(this.sliderContainer, this.options);
	}
}

if (!window.customElements.get("pazzles-picker-thumb-slider")) {
	window.customElements.define("pazzles-picker-thumb-slider", PazzlesPickerThumbSlider);
}

class PazzlesPickerMainSlider extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.initElements();
		this.initSlider();
	}

	initElements() {
		this.thumbSlider = this.closest("[data-pazzles-picker-tab-gallery]")?.querySelector("[data-pazzles-picker-thumb-gallery]");
	}

	initSlider() {
		this.sliderContainer = this.querySelector("[data-pazzles-picker-main-gallery]");

		if (!this.sliderContainer) {
			return null;
		}

		this.mainOptions = {
			slidesPerView: "auto",
			spaceBetween: 0,
			observer: true,
			observeParents: true,
			thumbs: {
				swiper: this.thumbSlider
			},
			pagination: {
				el: "[data-pazzles-picker-main-gallery-pagination]",
				clickable: true
			}
		}

		this.slider = new Swiper(this.sliderContainer, this.mainOptions);
	}


}

if (!window.customElements.get("pazzles-picker-main-slider")) {
	window.customElements.define("pazzles-picker-main-slider", PazzlesPickerMainSlider);
}
